import { coreLogger } from "helpers/logger";
import isString from "./isString";
import includes from "./includes";

export const USER_AGENT = "CookieCheck";
const isScannerApp = (): boolean => {
  const ua = navigator.userAgent;
  const result = isString(ua) && includes(ua, USER_AGENT);
  if (result) {
    coreLogger("is Scanner.");
  }

  return result;
};

export default isScannerApp;
